import MobilePaidsList from "./styles";

export default MobilePaidsList;
